import { useAppNotifications } from "@/hooks/useAppNotifications";
import { TOAST_AUTO_HIDE_DURATION } from "@/constants";

export function useClipboardCopy() {
  const notifications = useAppNotifications();

  const copy = async (text: string, message: string) => {
    await navigator.clipboard.writeText(text);

    notifications.show(message, {
      severity: "success",
      autoHideDuration: TOAST_AUTO_HIDE_DURATION,
    });
  };

  return { copy };
}
